import { TaskJson, CreateTaskPayload } from 'common/types';
import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';
// 任务实例化/编辑任务

export interface TaskTemplateCreateParams extends CreateTaskPayload {
  stages: TaskJson[];
}
export interface UpdateParentTaskParams extends CreateTaskPayload {
  stageTemplateSortList: TaskJson[];
}

const taskInstance = {
  createParentTaskWithTemplate: async (query: TaskTemplateCreateParams) => {
    const params = {};
    try {
      const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
        '/api/v1/template/createTasksWithTemplate',
        { ...query },
      );
      return { data, code, message };
    } catch (error: any) {
      return { code: error?.code, message: error?.message };
    }
  },
  updateParentTask: async (parentTaskId: number, update: UpdateParentTaskParams) => {
    try {
      const res = await FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v1/task/updateParentTask', {
        ...getNormalParams('updateParentTask'),
        parentTaskId,
        ...update,
      });
      return res;
    } catch (error: any) {
      return { code: error?.code, message: error?.message };
    }
  },
  passParentTask: async (parentTaskId: number) => {
    try {
      const res = await FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v1/task/pass', {
        ...getNormalParams('passParentTask'),
        parentTaskId,
      });
      return res;
    } catch (error: any) {
      return { code: error?.code, message: error?.message };
    }
  },
  //撤销结算
  cancelSettlement: async (parentTaskId: number) => {
    return FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v2/task/cancelSettlement', { parentTaskId });
  },
  getParentTaskUpdateInfo: async ({ parentTaskId }) => {
    try {
      const params = { ...getNormalParams('getParentTaskUpdateInfo'), parentTaskId };
      const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/task/getParentTaskUpdateInfo', {
        params,
      });
      return data;
    } catch (error) {
      return false;
    }
  },
  removeTask: async (taskId: number) => {
    try {
      const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
        '/api/v1/task/removeTask',
        {
          ...getNormalParams('removeTask'),
          taskId,
        },
      );
      return code === 0;
    } catch (error) {
      return false;
    }
  },
  updateTask: async (taskId: number, update: TaskJson) => {
    try {
      const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
        '/api/v1/task/updateTask',
        {
          ...update,
          ...getNormalParams('updateTask'),
          taskId,
        },
      );
      return code === 0;
    } catch (error) {
      return false;
    }
  },
  listGroups: async (params: { search?: string; limit?: number; page?: number }) => {
    try {
      const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/task/listGroups', {
        params: {
          ...getNormalParams('listGroups'),
          search: params.search,
          limit: params.limit || 20,
          page: params.page || 1,
        },
      });
      return data?.items || data || [];
    } catch (error) {
      return [];
    }
  },
};

export default taskInstance;
